import { TypeProcess } from '../../interfaces/TypeProcess/TypeProcess'
import { TypeProcessAction } from '../actions/typeProcessActions'
import { GET_TYPE_PROCESS_EXITO } from '../types/typeProcessActionsTypes'

export interface TypeProcessState {
  typeProcessState: {
    typeProcess?: TypeProcess[]
    error?: string | undefined
  }
}

const initialState: TypeProcessState = {
  typeProcessState: { typeProcess: [], error: '' }
}

export const typeProcessReducer = (
  state: TypeProcessState = initialState,
  action: TypeProcessAction
): TypeProcessState => {
  if (action.type === GET_TYPE_PROCESS_EXITO) {
    return {
      ...state,
      typeProcessState: {
        typeProcess: action.typeProcess,
        error: action.error
      }
    }
  }
  return state
}
